<template>
  <div class="md-layout">
    <md-table md-card @md-selected="onSelect" md-sort-order="asc">
      <md-table-toolbar>
        <div class="md-toolbar-section-start md-layout-item md-size-50">
          <h1 class="md-title">{{ title }}</h1>
        </div>

        <div class="md-toolbar-section-end md-layout-item md-size-33 ml-auto">
          <md-field md-clearable class="md-toolbar-section-start md-layout-item">
            <md-input placeholder="Buscar folio" v-model="search" @input="searchOnTable" />
          </md-field>
          <div class="ml-auto">
            <slot name="title-actions"></slot>
          </div>
        </div>
      </md-table-toolbar>

      <md-table-toolbar slot="md-table-alternate-header" slot-scope="{ count }">
        <div class="md-toolbar-section-start">{{ getAlternateLabel(count) }}</div>
      </md-table-toolbar>

      <md-table-row>
        <md-table-head></md-table-head>
        <md-table-head v-for="(title, index) in tableHeaders" :key="index">
          <div v-if="title.value === 'total'">
            <md-button class="md-icon-button" @click="sortByTotal">
              <md-icon v-if="sortTotal">arrow_upward</md-icon>
              <md-icon v-else>arrow_downward</md-icon>
            </md-button>
            <span>{{ title.text }}</span>
          </div>
          <span v-else>{{ title.text }}</span>
        </md-table-head>
      </md-table-row>

      <template v-for="item in searched">
        <md-table-row ref="rowTable" :key="item.id" slot="md-table-row">
          <md-table-cell>
            <md-button
              class="md-round md-just-icon"
              @click="
                visibleRequisitions[item.id] = !visibleRequisitions[item.id]
              "
            >
              <md-icon>
                {{
                !visibleRequisitions[item.id] ? "expand_more" : "expand_less"
                }}
              </md-icon>
              <md-tooltip>Ver</md-tooltip>
            </md-button>
          </md-table-cell>

          <template v-for="(title, index) in tableHeaders">
            <md-table-cell
              v-if="title.value === 'total'"
              :md-label="title.text"
              :key="index"
            >{{ item[title.value] }}</md-table-cell>
            <md-table-cell v-else :md-label="title.text" :key="index">
              {{ item[title.value] }}
              <md-tooltip v-if="title.value === 'highway'">
                {{
                item.rfc || ""
                }}
              </md-tooltip>
            </md-table-cell>
          </template>

          <md-table-cell v-if="showSelect" md-label="Seleccionar">
            <md-checkbox ref="checkAffected" class="md-fail" v-model="selected" :value="item"></md-checkbox>
          </md-table-cell>

          <md-table-cell v-if="hasActions" md-label="Acciones">
            <div class="md-layout md-gutter md-alignment-center">
              <md-button
                v-for="action in actions"
                :key="action.icon"
                class="md-just-icon md-success md-size-2x"
                @click.native="action.exe(item)"
              >
                <md-icon>{{ action.icon }}</md-icon>
              </md-button>
              <md-button
                v-if="title === 'Paquetes para aprobar'"
                class="md-icon-button md-success"
                @click="downloadProceedings(item.id, item.folio)"
              >
                <md-icon>archive</md-icon>
              </md-button>
              <md-button
                v-if="title === 'Paquetes'"
                class="md-layout-item md-icon-button md-size-2x md-primary"
                @click="editPackageSinister(item.id)"
              >
                <md-icon>edit</md-icon>
              </md-button>
              <md-button
                v-if="title === 'Paquetes'"
                class="md-layout-item md-icon-button md-size-2x md-success"
                @click="aprovePackage(item.id)"
              >
                <md-icon>done</md-icon>
              </md-button>
              <md-button
                v-if="title === 'Autorizados'"
                class="md-layout-item md-icon-button md-size-2x md-success"
                @click="addPaymentsToPackage(item.id)"
              >
                <md-icon>attach_money</md-icon>
              </md-button>
            </div>
          </md-table-cell>
        </md-table-row>

        <md-table-row :key="item.id" v-if="visibleRequisitions[item.id]">
          <md-table-cell colspan="7">
            <simple-table
              v-if="showSubTable"
              :tableData="item.relatedAffected"
              :tableHeaders="subTableHeaders"
              :showSelect="showSubSelect"
              @subSelected="onSubSelected"
              @saveSubItems="saveSubItems(item.id, item.relatedAffected)"
            ></simple-table>
          </md-table-cell>
        </md-table-row>
      </template>
    </md-table>
  </div>
</template>

<script>
import { SimpleTable } from "@/components";
import ExtranetService from "@/services/extranet";

const toLower = (text) => text.toString().toLowerCase();

const searchByName = (items, term) => {
  if (term) {
    return items.filter((item) => toLower(item.folio).includes(toLower(term)));
  }
  return items;
};

export default {
  name: "TableActions",
  props: {
    title: String,
    tableHeaders: Array,
    actions: Array,
    hasActions: {
      type: Boolean,
      default: true,
    },
    showSelect: {
      type: Boolean,
      default: true,
    },
    tableData: {
      type: Array,
      default: () => [],
    },
    showSubTable: {
      type: Boolean,
      default: false,
    },
    subTableHeaders: {
      type: Array,
      default: () => [],
    },
    subTableActions: {
      type: Array,
      default: () => [],
    },
    showSubSelect: {
      type: Boolean,
      default: () => false,
    },
    fetchedRelatedAffected: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    search: "",
    sortTotal: false,
    selected: [],
    searched: [],
    visibleRequisitions: null,
    subSelected: [],
  }),
  components: {
    SimpleTable,
  },
  computed: {
    total() {
      return this.tableData.length > 0
        ? this.tableData.length
        : this.tableData.length;
    },
  },
  methods: {
    sortByTotal() {
      this.sortTotal = !this.sortTotal;
      this.searched.sort((a, b) => {
        const aNum = Number(a.total.replace(/(^\$|,)/g, ""));
        const bNum = Number(b.total.replace(/(^\$|,)/g, ""));
        if (this.sortTotal) {
          if (aNum < bNum) {
            return 1;
          }
          return -1;
        }
        if (aNum > bNum) {
          return 1;
        }
        return -1;
      });
    },
    onSelect(items) {
      this.selected = items;
    },
    getAlternateLabel(count) {
      let plural = "requisición",
        plural1 = "";

      if (count > 1) {
        plural = "requisiciones";
        plural1 = "s";
      }

      return `${count} ${plural} seleccionada${plural1}`;
    },
    searchOnTable() {
      this.searched = searchByName(this.tableData, this.search);
    },
    onSubSelected(subItems) {
      this.subSelected = subItems;
      this.$emit("subSelected", this.subSelected);
    },
    saveSubItems(id, relatedAffected) {
      this.$emit("saveSubSelect", id, relatedAffected);
    },
    editPackageSinister(id) {
      this.$router.push({ path: `/extranet/edicion_para_extranet/${id}` });
    },
    aprovePackage(id) {
      ExtranetService.setVisible4Customer(id)
        .then(() => {
          this.$successMessage({
            title: "Aprobado",
            text: "El paquete fue aprobado correctamente y marcado como visible para el cliente",
          });
          this.$emit("aproved", id);
        })
        .catch(this.$fireErrorResponse);
    },
    addPaymentsToPackage(id) {
      this.$emit("addPayment", id);
    },
    downloadProceedings(id, folio) {
      this.$emit("downloadProceedings", id, folio);
    },
  },
  watch: {
    selected() {
      this.$emit("selected", this.selected);
    },
    tableData() {
      this.searched = this.tableData;
    },
    searched(value) {
      const visibleRequisitions = {};
      for (const item of value) {
        visibleRequisitions[item.id] = false;
      }

      this.visibleRequisitions = visibleRequisitions;
    },
    fetchedRelatedAffected(newVal) {
      if (newVal.length > 0) {
        this.$refs.checkAffected.forEach((b, index) => {
          newVal.forEach((a) => {
            if (b.value.id === a.id) {
              this.$refs.checkAffected[index].toggleCheck();
            }
          });
        });
      }
    },
  },
};
</script>

<style lang="css" scoped>
.md-table + .md-table {
  margin-top: 16px;
}
</style>



// WEBPACK FOOTER //
// src/pages/extranet/TableActions.vue